import React from 'react';

function Index() {
  return <div>FAQ</div>;
}

export default Index;
